/**
 * Checks if the cookie consent cookie is set.
 * @returns {boolean} True if the consent cookie exists and is set to 'true', false otherwise.
 */
export function getCookieConsent(): boolean {
  if (typeof document === 'undefined') {
    return false; // Cannot access cookies on the server
  }
  try {
    return document.cookie.includes('cookieConsent=true');
  } catch (e) {
    console.error('Error reading cookie consent:', e);
    return false; // Default to false if error occurs
  }
}

/**
 * Sets the cookie consent cookie.
 * @param {boolean} consentGiven - Whether consent was given. If true, sets the cookie; if false, this function currently does nothing but could be extended to remove the cookie.
 */
export function setCookieConsent(consentGiven: boolean): void {
  if (typeof document === 'undefined' || !consentGiven) {
    return; // Cannot set cookies on the server or consent not given
  }
  try {
    const expires = new Date();
    expires.setFullYear(expires.getFullYear() + 10); // Set expiry far in the future
    document.cookie = `cookieConsent=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax; Secure`; // Added Secure flag
  } catch (e) {
    console.error('Failed to set cookie consent:', e);
  }
}
